import { useEffect, useState } from "react"
import { AppText } from "~/ui/app-text"

// Largest non-zero unit downward (days → hours → minutes), mirroring the mobile predictions countdown.
function computeUnits(endsAt: string) {
  const secondsDiff = Math.floor((new Date(endsAt).getTime() - Date.now()) / 1000)
  if (secondsDiff <= 0) return [{ value: "0", unit: "MIN" }]

  const days = Math.floor(secondsDiff / 86400)
  const hours = Math.floor(secondsDiff / 3600) % 24
  const minutes = Math.floor((secondsDiff % 3600) / 60)

  const units: { value: string; unit: string }[] = []
  if (days >= 1) units.push({ value: String(days), unit: "D" })
  if (Math.floor(secondsDiff / 3600) >= 1) units.push({ value: String(hours), unit: "H" })
  units.push({ value: String(Math.max(minutes, days < 1 && hours < 1 ? 1 : 0)), unit: "MIN" })
  return units
}

export const PredictionsCountdown: React.FC<{ endsAt: string }> = ({ endsAt }) => {
  const [units, setUnits] = useState(() => computeUnits(endsAt))

  useEffect(() => {
    const id = setInterval(() => setUnits(computeUnits(endsAt)), 10_000)
    return () => clearInterval(id)
  }, [endsAt])

  return (
    <div className="flex flex-col items-center gap-2">
      <AppText variant="hairline-1" className="text-neutral-500">
        CLOSES IN:
      </AppText>
      <div className="flex flex-row items-baseline gap-2">
        {units.map(({ value, unit }) => (
          <div key={unit} className="flex flex-row items-baseline gap-1">
            <AppText variant="h2">{value}</AppText>
            <AppText variant="hairline-1">{unit}</AppText>
          </div>
        ))}
      </div>
    </div>
  )
}
